import { render } from "./IconMatchOther.vue?vue&type=template&id=c9322fda&ts=true"
import script from "./IconMatchOther.vue?vue&type=script&lang=ts"
export * from "./IconMatchOther.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__